import React from "react";

const HeaderSection = ({title, subtitle}) => {
  return (
    <div className="pt-[5.5rem] lg:pt-24 ">
      <section className="dark:bg-jacarta-800 relative py-14 md:py-16">
        <picture className="pointer-events-none absolute inset-0 -z-10 dark:hidden">
          <img src="/images/gradient_light.jpg" alt="gradient" className="h-full w-full"/>
        </picture>
        <div className="container">
          <h1 className="font-display text-jacarta-700 text-center text-4xl font-medium dark:text-white">
            {title}
          </h1>
          <div className="article-content mx-auto max-w-[48.125rem]">
            <p className="text-center">{subtitle}</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HeaderSection;
